/* src/app/oversign-time/oversign-time-presenter/oversign-time-presenter.component.scss */
/*# sourceMappingURL=oversign-time-presenter.component.css.map */
